<template>
  <div>
    <div style="border-bottom: 1px solid #ECECEC;">
      <div style="padding:100px 0;margin:auto;width:1200px;">
        <div class="company left">
          <p>热线：4008-365596</p>
          <p>商务合作：caoqifan@ttq.so</p>
          <p>微信客服：ttqcare</p>
        </div>
        <div class="companyErcode right">
          <div class="left" style="margin-right:50px">
            <img src="../../site/weibo.png">
            <p>官方微博</p>
          </div>
          <div class="left" style="margin-right:50px">
            <img src="../../site/gongzhonghao.png">
            <p>官方公众号</p>
          </div>
          <div class="left" style="margin-right:50px">
            <img src="../../site/shipinhao.png">
            <p>官方视频号</p>
          </div>
          <div class="left">
            <img src="../../site/douyin.png">
            <p>抖音号</p>
          </div>
          <div style="clear:both"></div>
        </div>
        <div style="clear:both"></div>
      </div>
    </div>
    <div class="beian">
      <a target="_blank" href="https://beian.miit.gov.cn/" style="color:#00b9cd">粤ICP备14072944号</a>  |   版权所有权Copyright @ 2014-2024 深圳市爱宝惟生物科技有限公司  |   地址：广东省深圳市宝安西乡街道宝民二路IDT研发中心4层  |  电话：0755-29299992                
    </div>


  </div>
</template>

<script>

  export default {
    name: 'footerBottomer',
    data () {
      return {
      }
    },

    mounted() {
   
  	},
    methods: {
      
    },
   
  }
</script>
<style scoped>
  .left{float: left;}
  .right{float: right;}
  .company{font-size: 14px;color:#4f4f4f;line-height: 35px;}
  .companyErcode{font-size:14px;color:#4f4f4f;text-align: center;}
  .companyErcode img{width: 80px;}
  .beian{font-size:12px;color:#999999;text-align: center;padding: 45px 0;}
</style>




// WEBPACK FOOTER //
// footerBottomer.vue?089a4e08